import React from "react";
import {Button} from "react-bootstrap";

const clampPercent = (value) => Math.max(0, Math.min(100, Number(value) || 0));

const formatDuration = (seconds) => {
  if (seconds == null || !Number.isFinite(Number(seconds))) return null;
  const value = Math.max(0, Math.ceil(Number(seconds)));
  if (value < 60) return `${value} s`;
  const minutes = Math.floor(value / 60);
  const rest = value % 60;
  if (minutes < 60) return rest > 0 ? `${minutes} min ${rest} s` : `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  const restMinutes = minutes % 60;
  return restMinutes > 0 ? `${hours} h ${restMinutes} min` : `${hours} h`;
};

const ScheduleGenerationProgress = ({progress, onCancel}) => {
  if (!progress) return null;

  const percent = clampPercent(progress.percent);
  const status = progress.status || "RUNNING";
  const completed = Number(progress.completedItems) || 0;
  const total = Number(progress.totalItems) || 0;
  const eta = formatDuration(progress.estimatedRemainingSeconds);
  const elapsed = formatDuration(progress.elapsedSeconds);
  const title = status === "COMPLETED"
    ? "Generowanie zakończone"
    : status === "CANCELLED"
      ? "Generowanie przerwane"
      : status === "CANCELLING"
        ? "Anulowanie generowania"
        : status === "FAILED"
          ? "Generowanie przerwane"
          : "Generowanie grafiku";

  return (
    <div className={`schedule-generation-progress schedule-generation-progress-${status.toLowerCase()}`}>
      <div className="schedule-generation-progress-heading">
        <strong>{title}</strong>
        <span>{Math.round(percent)}%</span>
      </div>
      <div
        className="schedule-generation-progress-track"
        role="progressbar"
        aria-valuemin="0"
        aria-valuemax="100"
        aria-valuenow={Math.round(percent)}
        aria-label="Postęp generowania grafiku"
      >
        <div className="schedule-generation-progress-bar" style={{width: `${percent}%`}} />
      </div>
      <div className="schedule-generation-progress-details">
        <span><b>Etap:</b> {progress.phase || "Przygotowanie"}</span>
        {total > 0 && <span><b>Pozycje:</b> {completed}/{total}</span>}
        {status === "RUNNING" && <span><b>Pozostało:</b> {eta ? `około ${eta}` : "szacowanie…"}</span>}
        {elapsed && <span><b>Czas:</b> {elapsed}</span>}
      </div>
      {progress.currentItemLabel && status === "RUNNING" && (
        <div className="schedule-generation-progress-current">{progress.currentItemLabel}</div>
      )}
      {status === "FAILED" && progress.errorMessage && (
        <div className="schedule-generation-progress-error">{progress.errorMessage}</div>
      )}
      {(status === "RUNNING" || status === "CANCELLING") && onCancel && (
        <div className="schedule-generation-progress-actions">
          <Button
            type="button"
            variant="outline-danger"
            size="sm"
            onClick={onCancel}
            disabled={status === "CANCELLING"}
          >
            {status === "CANCELLING" ? "Anulowanie..." : "Przerwij generowanie"}
          </Button>
        </div>
      )}
    </div>
  );
};

export default ScheduleGenerationProgress;
